import { useState, useEffect } from 'react';

export default function IntroSplash() {
  const [visible, setVisible] = useState(true);

  // Masquer automatiquement l'écran d'accueil après un court délai
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 2600);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center overflow-hidden">
      <div className="flex flex-col items-center gap-6 animate-slideUpFade">
        {/* Logo de la clinique */}
        <img
          src="https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/brand/logo.jpeg"
          alt="Logo Clinique Sainte Famille"
          className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover animate-pulse"
        />

        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-clinic-blue-dark tracking-wide">
            Clinique Sainte Famille
          </h1>
          <p className="text-sm md:text-base text-gray-500 mt-2 font-medium">
            Votre santé, notre priorité
          </p>
        </div>

        {/* Petits points animés */}
        <div className="flex gap-2 mt-2">
          <span className="w-2 h-2 rounded-full bg-clinic-blue animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-2 h-2 rounded-full bg-clinic-blue animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-2 h-2 rounded-full bg-clinic-blue animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}